import script from "./AddCategoryForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCategoryForm.vue?vue&type=script&setup=true&lang=js"

import "./AddCategoryForm.vue?vue&type=style&index=0&id=5b9bfd46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b9bfd46"]])

export default __exports__